import React from 'react';
import { useHistory } from 'react-router-dom';
import { EyeOutlined } from '@ant-design/icons';
import { Calendar, Skeleton } from 'antd';
import Wrapper from './style';
import { Card, Button, TabMenu } from '..';
import baseUrl from '../../configs/baseUrl';
import DASHBOARD_CONFIG, { INTEGRATOR_MENUS } from '../../configs/dashboard';

const Index = (props) => {
  const {
    onChangePanel,
    title = '',
    value,
    onSelect,
    onClickPromoter,
    totalPromoter,
    isLoading,
    selectedLevel = DASHBOARD_CONFIG.INTEGRATOR_LEVEL.CAMPAIGN,
    setSelectedLevel,
  } = props;

  const history = useHistory();
  return (
    <Wrapper>
      <Card>
        <div className="component_calendar_header_wrapper">
          <div className="font-subtitle1_medium">{title}</div>
          <Button
            type="default"
            onClick={() => {
              return history.push(baseUrl.DASHBOARD_FULL_CALENDAR);
            }}
          >
            <EyeOutlined />
            Full View
          </Button>
        </div>
        <TabMenu
          menus={INTEGRATOR_MENUS}
          selectedMenu={selectedLevel}
          setSelectedMenu={setSelectedLevel}
          menuColor="green"
          className="container_integrator_tab_menu"
          style={{ marginBottom: '12px' }}
        />
        <Calendar
          fullscreen={false}
          onChangePanel={onChangePanel}
          value={value}
          onSelect={onSelect}
        />
        <div
          className="component_calendar_content"
          onClick={onClickPromoter}
          aria-hidden="true"
          style={{ cursor: totalPromoter === 0 ? 'default' : 'pointer' }}
        >
          <div className="font-caption_medium">
            {value.format('DD MMMM YYYY')}
          </div>
          {isLoading ? (
            <Skeleton active title paragraph={false} />
          ) : (
            <div
              className={`font-paragraph_medium ${
                totalPromoter > 0 && 'orange'
              }`}
            >
              {`${totalPromoter} Ongoing Ads`}
            </div>
          )}
        </div>
      </Card>
    </Wrapper>
  );
};

export default Index;
